import { Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { themeOptions } from 'assets/styles/theme';

export const Title = styled(Typography)`
  color: ${themeOptions.palette?.text?.primary};
  font-size: 21px;
  font-weight: ${themeOptions.typography.fontWeightMedium};
  margin: 16px 0 25px;
`;

export const ImageContainer = styled('img')`
  max-width: 260px;
  border-radius: 6px;
  width: 100%;
`;

export const FilePreviewGrid = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 260px;
`;

export const FilePreviewThumb = styled('img')`
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 6px;
`;

export const SignaturePreviewContainer = styled('img')`
  border: 1px solid ${themeOptions.palette.primary.light};
  border-radius: 8px;
  max-width: 290px;
  max-height: 230px;
`;

export const DrawPreviewContainer = styled('img')`
  border: 1px solid ${themeOptions.palette.primary.light};
  border-radius: 8px;
  max-width: 290px;
  max-height: 230px;
`;
export const SubTitle = styled(Typography)`
  color: ${themeOptions.palette?.text?.primary};
  font-size: 14px;
  font-weight: ${themeOptions.typography.fontWeightRegular};
  margin-bottom: 68px;

  span {
    display: inline-flex;
    font-weight: ${themeOptions.typography.fontWeightBold};
  }

  svg {
    margin-top: -3px;
    color: ${themeOptions.palette.primary.main};
  }
`;

export const SummaryCard = styled(Box)`
  margin: -45px auto 40px;
  max-width: 370px;
  padding: 16px;
  background: #FFFFFF;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.15);
  border-radius: 5px;

  hr {
    margin: 16px 0;

    &:last-child {
      display: none;
    }
  }
`;

export const TitleCard = styled(Typography)`
  color: ${themeOptions.palette?.text?.primary};
  font-size: 21px;
  font-weight: ${themeOptions.typography.fontWeightMedium};
  margin-bottom: 16px;
`;

export const NoteGroup = styled(Box)`
  max-height: 300px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 5px;
    padding-left: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ccc;
  }
`;

export const Note = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #141414;

  svg {
    color: ${themeOptions.palette.primary.main};
    cursor: pointer;
    transition: filter 0.5s;

    &:hover {
      filter: brightness(0.8);
    }
  }
`;

export const ButtonGroup = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 16px;
`;
